import PrivacyContact from './contact'

export default PrivacyContact
